import http from "utils/http";

const zonesApi = {
  getZones: async () => http.get<Zone[]>("/api/zones/ob/zones/"),
};

export default zonesApi;
